var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fields && _vm.fields.length)?_c('v-row',{staticClass:"pa-3 ma-10"},_vm._l((_vm.fields),function(input,idx){return _c('v-col',{key:idx},[_c('FormLabel',{attrs:{"input":input}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }